import { render } from "./bucket-list-category.vue?vue&type=template&id=04ae255d&scoped=true"
import script from "./bucket-list-category.vue?vue&type=script&lang=js"
export * from "./bucket-list-category.vue?vue&type=script&lang=js"

import "./bucket-list-category.vue?vue&type=style&index=0&id=04ae255d&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04ae255d"]])

export default __exports__